

import OpenCover from '../../components/openCover';
export default function() {
  //开场封面
  const { configOpenCover } = this.params;
  const { openCover } = this;
  if (!configOpenCover || openCover) return;
  const newopenCover = new OpenCover({
    wrapper: this.$container.get(0),
    ...configOpenCover,
  });
  this.openCover = newopenCover;
}
